import type { FinalCTAContent } from "../../types/page-content";

interface Props {
  content: FinalCTAContent;
  onEstimateClick: () => void;
  sectionNumber?: string;
}

export default function FinalCTASection({ content, onEstimateClick, sectionNumber = "09" }: Props) {
  return (
    <section className="bg-safety-500 py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute right-6 top-0 hidden xl:block">
        <span className="font-heading text-asphalt-950/[0.06] text-[180px] leading-none select-none">{sectionNumber}</span>
      </div>

      {/* Background grid pattern */}
      <div className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-14">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-asphalt-950/10 px-4 py-1.5 mb-6">
              <div className="w-1.5 h-1.5 bg-asphalt-950 rounded-full" />
              <span className="font-body text-asphalt-950 text-xs uppercase tracking-widest2 font-700">
                {content.urgencyLabel}
              </span>
            </div>
            <h2 className="font-heading text-asphalt-950 text-6xl lg:text-8xl tracking-display leading-none mb-4">
              {content.heading}
            </h2>
            <p className="font-body text-asphalt-800 text-base lg:text-lg">{content.subheading}</p>
          </div>

          <div className="flex flex-col gap-4 flex-shrink-0 w-full lg:w-auto">
            <button
              onClick={onEstimateClick}
              className="flex items-center justify-center gap-3 bg-asphalt-950 text-safety-500 font-body font-800 text-sm uppercase tracking-widest px-12 py-5 hover:bg-asphalt-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-lg" />
              Request Free Estimate
            </button>
            <a
              href="tel:5558007283"
              className="flex items-center justify-center gap-3 border-2 border-asphalt-950 text-asphalt-950 font-body font-800 text-sm uppercase tracking-widest px-12 py-5 hover:bg-asphalt-950 hover:text-safety-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-lg" />
              Call (555) 800-7283
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
